import script from "./StudentImport.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentImport.vue?vue&type=script&setup=true&lang=js"

import "./StudentImport.vue?vue&type=style&index=0&id=06c12886&lang=css"

const __exports__ = script;

export default __exports__